export default __webpack_public_path__ + "static/media/tick_circle.a83ffa7a.svg";